import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 90000 });

export async function acceptDisclaimer({ fullName }) {
  const { data } = await api.post("/disclaimer/accept", {
    full_name: fullName || "",
    user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "",
  });
  return data;
}

export async function analyze(payload, useAi = true, audience = "owner", sampleMode = false) {
  const { data } = await api.post("/analyze", {
    data: payload,
    use_ai: useAi,
    audience,
    sample_mode: sampleMode,
  });
  return data;
}

export async function fetchSampleData(variant = "healthy") {
  const { data } = await api.get("/sample-data", { params: { variant } });
  return data;
}

export async function fetchSampleVariants() {
  const { data } = await api.get("/sample-data/variants");
  return data.variants || [];
}

export async function submitFeedback(payload) {
  const { data } = await api.post("/feedback", payload);
  return data;
}

export async function fetchRegions() {
  const { data } = await api.get("/regions");
  return data.regions || [];
}

export async function fetchPeerStats({ industry, region, minN = 5 }) {
  const { data } = await api.get("/peer-stats", {
    params: { industry, region, min_n: minN },
  });
  return data;
}

export async function fetchLeaderboard(minN = 5) {
  const { data } = await api.get("/leaderboard", { params: { min_n: minN } });
  return data;
}

export async function uploadFinancialFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
